import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * Poll the unread-notification count every 30 s. Used by HeaderBell
 * (and previously by TabBar). Cheap index-only count query.
 */
export function useUnreadCount() {
  return useQuery({
    queryKey: ['notifications-unread'],
    queryFn: () => api.get<{ count: number }>('/notifications/unread-count'),
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
